import type { TransKey } from '@root/shared/localization'

export const PERIODS = ['1H', '6H', '12H', '24H', '7D', 'ALL'] as const
export type Period = (typeof PERIODS)[number]

export const PERIOD_LABEL_MAP: Record<Period, TransKey> = {
  ALL: 'common.period.all',
  '7D': 'common.period.7d',
  '24H': 'common.period.1d',
  '12H': 'common.period.12h',
  '6H': 'common.period.6h',
  '1H': 'common.period.1h',
}
